import './payday.css';

import paydayImg from './../../img/images/promo-img.jpg'

const Payday = () => {
   return (
      <section className="payday">
         <div className="container">
            <div className="payday__body">
               <div className="payday__img">
                  <img src={paydayImg} alt="" />
               </div>
               <div className="payday__info">
                  <h2 className="payday__title"><span className="payday__title-bg"><span>PAYDAY</span></span> SALE NOW</h2>
                  <div className="payday__txt">
                     <p>Spend minimal $100 get 30% off voucher code for your next purchase</p>
                     <p className="payday__text-bold">1 June - 10 June 2021</p>
                     <p>*Terms & Conditions apply</p>
                  </div>
                  <div className="payday__btn">
                     <a href="#!" className='payday__link'>SHOP NOW</a>
                  </div>
               </div>
            </div>
         </div>
      </section>
   );
}

export default Payday;